import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { enqueueSnackbar } from '../../root/actions'
import {
    getIntegrationSettings,
    patchIntegrationSettings
} from '../api/integrations-api'
import { INTEGRATIONS_AND_API_DATA_KEY } from './use-integrations-and-api-data'

const integrationSettingsKey = customerId => [
    'integration-settings',
    customerId
]

export function useIntegrationSettings(customerId) {
    const dispatch = useDispatch()
    const locale = useSelector(state => state.main.locale)

    return useQuery(
        integrationSettingsKey(customerId),
        () => getIntegrationSettings(customerId),
        {
            enabled: Boolean(customerId),
            refetchOnWindowFocus: false,
            onError: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.integrations.loadFailed,
                        options: { variant: 'error' }
                    })
                )
            }
        }
    )
}

export function usePatchIntegrationSettings(customerId) {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    const locale = useSelector(state => state.main.locale)

    return useMutation(body => patchIntegrationSettings(customerId, body), {
        onSuccess: () => {
            queryClient.invalidateQueries(integrationSettingsKey(customerId))
            queryClient.invalidateQueries(INTEGRATIONS_AND_API_DATA_KEY)
            dispatch(
                enqueueSnackbar({
                    message: locale.integrations.settingsUpdated,
                    options: { variant: 'success' }
                })
            )
        },
        onError: () => {
            dispatch(
                enqueueSnackbar({
                    message: locale.integrations.settingsUpdateFailed,
                    options: { variant: 'error' }
                })
            )
        }
    })
}
